const hasPayingOption = require('./hasPayingOption');

/**
 * Check if the user can access the Document Analyzer
 * @param {Boolean} isExpired - true if the user is expired
 * @param {string} plan - user plan
 * @param {Array<string>} payingOptions - list of options for the user
 * @param {Boolean} isLoggedIn - true if the user is logged in
 */
const canAccessDocumentAnalyzer = (
  isExpired,
  plan,
  payingOptions,
  isLoggedIn,
) => {
  return (
    isLoggedIn &&
    !isExpired &&
    hasPayingOption(payingOptions, 'document_analyzer')
  );
};

/**
 * Check if the user can see the Document Analyzer feature
 * @param {string} plan - user plan
 * @param {Array<string>} payingOptions - list of options for the user
 * @param {Boolean} isLoggedIn - true if the user is logged in
 */
const canSeeDocumentAnalyzer = (plan, payingOptions, isLoggedIn) => {
  return isLoggedIn && hasPayingOption(payingOptions, 'document_analyzer');
};

module.exports = {
  canAccessDocumentAnalyzer,
  canSeeDocumentAnalyzer,
};
